
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  props: {
    icon: {
      type: String,
      required: true,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    title: {
      type: String,
      required: false,
    },
  },
});
